import { Box, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import { useState } from 'react'
import { FilteringSearchBar } from '../../components/inputs/FilteringSearchBar'
import { ActivityConfigurationCard } from './ActivityCard'
import { useWorkflowStore } from './stores/WorkflowStore'

/**
 * display all the activity options
 */
export const ActivityOptions = observer(() => {
	const { activityConfigurationStore } = useWorkflowStore()
	const [filteredActivities, setFilteredActivities] = useState(
		activityConfigurationStore.configurations,
	)

	const handleFilterActivities = (matches?: number[]) => {
		if (!matches)
			return setFilteredActivities(activityConfigurationStore.configurations)

		setFilteredActivities(matches.map((v) =>
			activityConfigurationStore.configurations[v]
		))
	}

	return (
		<Box
			height="100%"
			width="100%"
			padding={3}
			display="flex"
			flexDirection="column"
			gap={3}
		>
			<Typography variant="h5">Add an Activity</Typography>
			<FilteringSearchBar
				dataSet={activityConfigurationStore.configurations
					.map((c) => [c.displayName, c.category])
				}
				onQuery={(matches) => handleFilterActivities(matches)}
			/>
			{[...new Set(filteredActivities.map((v) => v.category))].map(
				(category) => (
					<Box display="flex" flexDirection="column" gap={0.5} key={category}>
						<Typography variant="h6">{category}</Typography>
						<Box display="flex" flexDirection="column" gap={1.5}>
							{filteredActivities
								.filter((v) => v.category === category)
								.map((activity) => (
									<Box
										key={activity.definitionId}
										component={ActivityConfigurationCard}
										border={1}
										borderColor={(theme) => theme.palette.grey[500]}
										activityTitle={activity.displayName}
										description={activity.description}
										icon={activity.icon}
										boxShadow={0}
										uniqueId={activity.definitionId}
									/>
								))}
						</Box>
					</Box>
				),
			)}
		</Box>
	)
})
